export default __webpack_public_path__ + "static/media/restart.b67589ae.svg";